export const contractManagementRouter = [
  //  合同模板管理
  {
    path: '/contractManagement/contractTemplate',
    name: 'contractTemplate',
    component: () => import('../views/contractManagement/contractTemplate')
  },
  //  新增&编辑 合同模板
  {
    path: '/contractManagement/addOrEdit',
    name: 'addOrEdit',
    component: () => import('../views/contractManagement/addOrEdit')
  },
  // 合同管理--合同列表
  {
    path: '/contractManagement/ContractList',
    name: 'ContractList',
    component: () => import('../views/contractManagement/ContractList')
  },
  // 合同管理--员工电子签审核
  {
    path: '/contractManagement/employeeSignReview',
    name: 'employeeSignReview',
    component: () => import('../views/contractManagement/employeeSignReview')
  },
  // 合同管理--员工电子签审核详情
  {
    path: '/contractManagement/employeeSignReviewEditOrSee',
    name: 'employeeSignReviewEditOrSee',
    component: () => import('../views/contractManagement/employeeSignReviewEditOrSee')
  },
]